<template>
  <svg
    v-bind="$attrs"
    class="arrow-icon"
    :class="direction"
    width="44"
    height="42"
    viewBox="0 0 44 42"
    :fill="$store.registrator_text_btn"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8747 18.3336H43.3333V23.667H10.8747L25.1787 37.971L21.408 41.7416L0.666656 21.0003L21.408 0.258972L25.1787 4.02964L10.8747 18.3336Z" />
  </svg>
</template>

<script>
const ARROW_DIRECTION = ['left', 'up', 'right', 'down'];

export default {
  props: {
    direction: {
      type: String,
      default() {
        return ARROW_DIRECTION[0];
      },
      validator(direction) {
        return ARROW_DIRECTION.includes(direction);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.arrow-icon {
  &.up {
    transform: rotate(90deg);
  }

  &.down {
    transform: rotate(-90deg);
  }

  &.right {
    transform: rotate(-180deg);
  }
}
</style>
